import { memo } from 'react';

const EmptyBox = () => (
  <svg width="174" height="115" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M165.97 15.4c-1.03 0-2 .2-2.9.58A20.05 20.05 0 0 0 143.5 0a20.1 20.1 0 0 0-19.8 23h49.8c0-4.2-3.37-7.6-7.53-7.6ZM31.17 110.67c-.13 0-.25 0-.37.02a11.5 11.5 0 0 0-22.47-2.6A5.92 5.92 0 0 0 .65 115H35.5c0-2.4-1.94-4.33-4.33-4.33Z"
        fill="#88E2E9"
      />
      <mask
        id="b"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="22"
        y="13"
        width="118"
        height="94"
      >
        <path d="M140 13.51H22v92.97h118V13.52Z" fill="#fff" />
      </mask>
      <g mask="url(#b)">
        <path d="M74.66 59.33h-28.1v43.92h28.1V59.33Z" fill="#EE399E" />
        <path
          d="M71.42 62.58V100H49.79V62.58h21.63Zm6.48-6.49H43.3v50.4h34.6v-50.4Z"
          fill="#F470BD"
        />
        <path
          d="M111.97 13.52H43.29v42.57h68.68V13.52ZM40.04 52.55a18.07 18.07 0 0 1-14.8-17.75c0-8.84 6.4-16.21 14.8-17.75v35.5Z"
          fill="#EE399E"
        />
        <path
          d="M36.8 21.5v26.61a14.81 14.81 0 0 1 0-26.6m6.49-8a21.3 21.3 0 0 0 0 42.58V13.52ZM136.76 59.33H81.15v43.92h55.6V59.33Z"
          fill="#F470BD"
        />
        <path
          d="M77.9 56.09v50.4H140v-50.4H77.9Zm55.61 43.9H84.4V62.58h15v12.68a3.73 3.73 0 0 0 3.72 3.73h11.46a3.73 3.73 0 0 0 3.73-3.73V62.57h15.21V100Z"
          fill="#F8B1DC"
        />
        <path
          d="m111.62 74.75-1.33-5.15a2.78 2.78 0 1 0-3.04-.09l-1.19 5.24h5.57Z"
          fill="#EE399E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.5)" d="M0 0h173v115H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(EmptyBox);
